import React, { useEffect, useRef, useState } from 'react';
import { injectIntl, useIntl } from 'react-intl';
import {
  extractIds,
  getLocalizedName,
  isAdminMode as _isAdminMode,
  anyConfigRequiresAdditionMapping,
} from '../../../../utility/util/util.service';
import { AvForm } from 'availity-reactstrap-validation';
import LocalizedNameField from '../../form/fields/LocalizedNameField';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import { connect } from 'react-redux';
import {
  closeModalSafely,
  getTranslationsCollapsable,
  handleSubmit,
} from './create-or-edit-item-addition-group.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import {
  setCreateItemAdditionGroupModalData,
  setIsCreateItemAdditionGroupModalOpen,
  setIsEditItemAdditionGroupModalOpen,
  setIsListAdditionsModalOpen,
} from '../../../../redux/modal/modal.actions';
import FormField from '../../form/fields/FormField';
import AdditionsField from '../../form/fields/AdditionsField';
import {
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuEntries,
  fetchMenuItems,
} from '../../../../redux/store/store.actions';
import { getOrderConditionsCollapsable } from '../modals.service';
import { Col, Row } from 'reactstrap';
import DropdownField from '../../form/fields/DropdownField';
import PosIntegrationRefField from '../../form/fields/PosIntegrationRefField';
import LabeledToggle from '../../form/LabeledToggle';

const CreateOrEditItemAdditionGroupModal = ({
  isCreateItemAdditionGroupModalOpen,
  isEditItemAdditionGroupModalOpen,
  createItemAdditionGroupModalData,
  editItemAdditionGroupModalData,
  store,
  allAdditions,
  menuEntriesData,
  me,

  setIsCreateItemAdditionGroupModalOpen,
  setIsEditItemAdditionGroupModalOpen,
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchMenuEntries,
  fetchMenuItems,
  fetchItemDatas,
  setIsListAdditionsModalOpen,
}) => {
  const [targetItemAdditionGroup, setTargetItemAdditionGroup] = useState({
    isActive: true,
  });
  const [targetOrderConditions, setTargetOrderConditions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTranslationsOpen, setIsTranslationsOpen] = useState(false);
  const [isOrderConditionsOpen, setIsOrderConditionsOpen] = useState(false);
  const [isAddOrderConditionOpen, setIsAddOrderConditionOpen] = useState(false);
  const [selectedOrderCondition, setSelectedOrderCondition] = useState(null);
  const [newOrderCondition, setNewOrderCondition] = useState({
    priority: null,
    minTotal: 0,
    maxTotal: null,
    minQty: 0,
    maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
    classes: ['inhouse', 'takeaway'],
  });
  const formRef = useRef(null);

  const isOpen =
    isCreateItemAdditionGroupModalOpen || isEditItemAdditionGroupModalOpen;
  const isEditMode = isEditItemAdditionGroupModalOpen;
  const { itemAdditionGroup, onSuccess } =
    (isEditMode
      ? editItemAdditionGroupModalData
      : createItemAdditionGroupModalData) || {};

  const isAdminMode = _isAdminMode(me, store?.slug);

  const intl = useIntl();
  const closeModal = () => {
    setIsOrderConditionsOpen(false);
    setIsAddOrderConditionOpen(false);
    setTargetItemAdditionGroup({ isActive: true });
    setTargetOrderConditions([]);
    setSelectedOrderCondition(null);
    setNewOrderCondition({
      priority: null,
      minTotal: 0,
      maxTotal: null,
      minQty: 0,
      maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
      classes: ['inhouse', 'takeaway'],
    });
    isCreateItemAdditionGroupModalOpen
      ? setIsCreateItemAdditionGroupModalOpen(false)
      : setIsEditItemAdditionGroupModalOpen(false);
  };
  const userLocale = intl?.locale;
  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);
  const _handleSubmit = (event, errors, values) =>
    handleSubmit(
      event,
      errors,
      values,
      targetItemAdditionGroup,
      isEditMode,
      setIsSubmitting,
      setTargetItemAdditionGroup,
      closeModal,
      async () => {
        const menuId = store?.menu?.id;
        const storeId = store?.id;
        await Promise.all([
          fetchFoodItemAdditions(isAdminMode, menuId, undefined, storeId),
          fetchMenuItems(isAdminMode, menuId, undefined, storeId),
          fetchItemDatas(isAdminMode, menuId, undefined, storeId),
        ]);
        await fetchAdditionGroups(isAdminMode, menuId, undefined, storeId);
        await fetchMenuEntries(
          menuId,
          isAdminMode,
          () => setIsListAdditionsModalOpen(true),
          storeId,
        );
      },
      targetOrderConditions,
      newOrderCondition,
      isAddOrderConditionOpen,
      store?.id,
    );
  const _getTranslationsCollapsable = () =>
    getTranslationsCollapsable(
      targetItemAdditionGroup,
      setTargetItemAdditionGroup,
      isTranslationsOpen,
      setIsTranslationsOpen,
      false,
      true,
      false,
      userLocale,
    );

  const _getOrderConditionsCollapsable = () => {
    return getOrderConditionsCollapsable(
      targetOrderConditions,
      setTargetOrderConditions,
      isOrderConditionsOpen,
      setIsOrderConditionsOpen,
      userLocale,
      isSubmitting,
      intl,
      isAddOrderConditionOpen,
      setIsAddOrderConditionOpen,
      newOrderCondition,
      setNewOrderCondition,
      null,
      null,
      selectedOrderCondition,
      setSelectedOrderCondition,
      true,
    );
  };

  useEffect(() => {
    if (isOpen) {
      setTargetItemAdditionGroup(
        (itemAdditionGroup && {
          ...itemAdditionGroup,
          additionIds: extractIds(
            itemAdditionGroup?.entries?.map(({ addition }) => addition),
          ),
          additions: itemAdditionGroup?.entries?.map(
            ({ addition }) => addition,
          ),
        }) || { isActive: true },
      );
      setTargetOrderConditions(itemAdditionGroup?.orderConditions);
    } else {
      // reset modal on closing
      setIsAddOrderConditionOpen(false);
    }
  }, [itemAdditionGroup, isOpen]);

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      title={intl.formatMessage({
        id: 'itemAdditionGroupLabel',
      })}
      footer={
        <div className="align-content-center">
          <SaveSubmitButton
            data-testid="submitButton"
            className="m-auto"
            isSubmitting={isSubmitting}
            onClick={() => formRef?.current.handleSubmit()}
          />
        </div>
      }
    >
      <div className="px-1">
        <AvForm
          ref={formRef}
          id="groupAdditionsForm"
          onSubmit={_handleSubmit}
          disabled={isSubmitting}
        >
          <LabeledToggle
            disabled={isSubmitting}
            wrapperClassName="d-flex align-content-center justify-content-between mt-2 mb-2"
            headingMessageId="isActiveLabel"
            headingClassName="d-block black"
            //propertyName="isActive"
            targetObject={targetItemAdditionGroup}
            checked={targetItemAdditionGroup?.isActive ?? true}
            onClick={() =>
              setTargetItemAdditionGroup({
                ...targetItemAdditionGroup,
                isActive: !targetItemAdditionGroup?.isActive,
              })
            }
          />
          <div className="mt-2">
            <Row>
              <Col xs={6} className="pr-50">
                <LocalizedNameField
                  data-testid="nameGroupField"
                  object={targetItemAdditionGroup}
                  locale={userLocale}
                  required
                />
              </Col>
              <Col xs={6} className="pl-50">
                <FormField
                  data-testid="freeOfCharge"
                  object={targetItemAdditionGroup}
                  propertyName="freeOfChargeSelections"
                  type="number"
                  messageId="freeOfChargeSelectionsLabel"
                />
              </Col>
            </Row>
            <AdditionsField
              object={targetItemAdditionGroup}
              setter={setTargetItemAdditionGroup}
              options={allAdditions || []}
              isDisabled={isSubmitting}
              store={store}
            />
            <DropdownField
              values={targetItemAdditionGroup?.itemDataIds || []}
              propertyName="itemDataIds"
              options={
                menuEntriesData?.filter(
                  (menuEntryData) => menuEntryData?.type === 'FoodItemData',
                ) || []
              }
              getOptionValue={(itemData) => itemData?.id}
              getOptionLabel={(itemData) =>
                getLocalizedName(itemData, intl.locale)
              }
              isMulti={true}
              placeholderMessageId="selectItemDatasLabel"
              labelMessageId="items"
              isDisabled={isSubmitting}
            />
            {anyConfigRequiresAdditionMapping(store) && (
              <PosIntegrationRefField
                placeholder={intl.formatMessage({
                  id: 'selectPosIntegrationRefLabel',
                })}
                type="itemAdditionGroup"
                propertyName="posIntegrationRef"
                object={targetItemAdditionGroup}
                setter={setTargetItemAdditionGroup}
              />
            )}
            {_getTranslationsCollapsable()}
            {_getOrderConditionsCollapsable()}
          </div>
        </AvForm>
      </div>
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isCreateItemAdditionGroupModalOpen:
    state.modals.isCreateItemAdditionGroupModalOpen,
  isEditItemAdditionGroupModalOpen:
    state.modals.isEditItemAdditionGroupModalOpen,
  createItemAdditionGroupModalData:
    state.modals.createItemAdditionGroupModalData,
  editItemAdditionGroupModalData: state.modals.editItemAdditionGroupModalData,
  allAllergens: state.store.foodAllergens,
  allPreferences: state.store.foodPreferences,
  allIngredients: state.store.foodIngredients,
  allAdditives: state.store.foodAdditives,
  allAdditions: state.store.foodItemAdditions,
  store: state.store.store,
  menuEntriesData: state.store.menuEntriesData,
  me: state.me.me,
});

export default connect(mapStateToProps, {
  setIsEditItemAdditionGroupModalOpen,
  fetchAdditionGroups,
  setIsCreateItemAdditionGroupModalOpen,
  setCreateItemAdditionGroupModalData,
  fetchFoodItemAdditions,
  fetchMenuEntries,
  fetchMenuItems,
  fetchItemDatas,
  setIsListAdditionsModalOpen,
})(injectIntl(CreateOrEditItemAdditionGroupModal));
